import moment from 'moment-timezone';
import { ArrayUtil } from 'helper-util';
import { getTimeZone } from '../services/clientConfigurationService';
import { IHoliday } from 'src/pages/SwapsTek/DashboardSlice';

// migrated
export const getTimeZoneFormattedDate = () => {
  const timeZone = getTimeZone();
  return moment.utc().tz(timeZone).format('YYYYMMDD');
};

export const getISODateFormat = () => {
  return moment().toISOString();
};
// migrated
export const getDateTimeBasedOnTimeZone = () => {
  const timeZone = getTimeZone();
  return `${moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ss')} (${moment.tz(timeZone).zoneAbbr()})`;
};

// migrated
export function formatResponseTime(date) {
  const timeZone = getTimeZone();
  return date && timeZone
    ? `${moment.utc(date).tz(timeZone).format('h:mm A')} (${moment.tz(timeZone).zoneAbbr()})`
    : '';
}

// migrated
export function recentLogTime(date: string) {
  const timeZone = getTimeZone();
  return date && timeZone ? moment.utc(date).tz(timeZone).format('MMM Do YYYY, ddd') : '';
}

// migrated
export function convertUTCDateToLocalTime(date) {
  const timeZone = getTimeZone();
  return date && timeZone ? moment.utc(date).tz(timeZone).format(' h:mm:ss A') : '';
}

// migrated
export function formatDate(date) {
  if (moment(date).isValid() && date.length === 3) {
    return moment([date[0], date[1] - 1, date[2]]).format('YYYY-MM-DD');
  } else return moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : date;
}

export function formatYear(date) {
  const m = moment(date, ['YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);

  return m.isValid() ? m.format('YYYY') : date;
}

// migrated
export function formatDateForPattern(date: string, pattern: string) {
  const timeZone = getTimeZone();
  return date && timeZone ? moment.utc(date).tz(timeZone).format('MMM DD YYYY') : '';
}

export const formatDateArray = (dateArray: number[]) => {
  const [year, month, day, hour, minute, second] = dateArray;
  const date = new Date(year, month - 1, day, hour, minute, second);
  return formatWithDateAndTime(date);
};

export const formatDateArrayShorter = (dateArray: number[]) => {
  const [year, month, day] = dateArray;
  const date = new Date(year, month - 1, day);
  return moment(date);
};

export const formatDateArrayTz = (dateArray: number[], timeZone?: any) => {
  const [year, month, day, hour, minute, second] = dateArray;
  const date = new Date(year, month - 1, day, hour, minute, second);
  return formatWithDateAndTime(date, timeZone);
};

// migrated
export const formatWithDateAndTime = (date, timeZoneVal?: any) => {
  const timeZone = timeZoneVal ? timeZoneVal : getTimeZone();
  return date && moment(date).isValid()
    ? timeZone
      ? timeZoneVal
        ? moment(date).format('YYYY-MM-DD HH:mm:ss') + `( ${timeZone})`
        : `${moment.utc(date).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')} (${moment.tz(timeZone).zoneAbbr()})`
      : `${moment.utc(date).format('YYYY-MM-DD HH:mm:ss')} (${moment.tz(moment.tz.guess()).zoneAbbr()})`
    : date;
};

// migrated
export const formatWithTime = (date) => {
  const timeZone = getTimeZone();
  return date && moment(date).isValid()
    ? timeZone
      ? moment.utc(date).tz(timeZone).format('HH:mm:ss')
      : moment.utc(date).format('HH:mm:ss')
    : date;
};

// migrated - check
export function convertDatetoIsoString(date) {
  return moment(date).toDate().toISOString();
}

// migrated - check
export function formatDateWith0s(date) {
  if (date && date.toString().length === 1) {
    return `0${date}`;
  } else return `${date}`;
}

// migrated
export const getDaysDifference = (finalDate: any, initialDate: any) => {
  return moment(finalDate.format('L')).diff(moment(initialDate.format('L')), 'days');
};

// to be migrated
export function getDateFromArray(date) {
  if (ArrayUtil.isEmpty(date)) {
    return moment();
  } else {
    const dateInUTCFormat = new Date(Date.UTC(date[0], date[1] - 1, date[2]));
    return moment.utc(dateInUTCFormat);
  }
}

// to be migrated
export function getFormattedDisplayTime(date) {
  const dateInUTCFormat = new Date(
    Date.UTC(
      date.value[0],
      date.value[1] - 1,
      date.value[2],
      date.value[3],
      date.value[4],
      date.value[5],
    ),
  );
  const timeZone = getTimeZone();
  return date && timeZone ? moment(dateInUTCFormat).tz(timeZone).format('h:mm:ss a') : '';
}

// to be migrated
export function getWeekDayAfterTwoWorkingDays(date) {
  var day = moment(date).day();
  var givenDate = moment(date);
  switch (day) {
    case 0:
    case 1:
    case 2:
    case 5:
      return moment(givenDate).add(3, 'days');
    case 3:
    case 6:
      return moment(givenDate).add(4, 'days');
    case 4:
      return moment(givenDate).add(5, 'days');
  }
}

// to be migrated
export function getWeekDayAfterOneWorkingDays(date) {
  var day = moment(date).day();
  var givenDate = moment(date);
  switch (day) {
    case 0:
    case 1:
    case 2:
    case 3:
      return moment(givenDate).add(2, 'days');
    case 6:
      return moment(givenDate).add(3, 'days');
    case 4:
    case 5:
      return moment(givenDate).add(4, 'days');
  }
}

// to be migrated
export function getWeekDay(date) {
  var day = moment(date).day();
  var givenDate = moment(date);
  while (day === 0 || day === 6) {
    givenDate = moment(givenDate).add(1, 'days');
    day = moment(givenDate).day();
  }
  return givenDate;
}

export const isValidDate = (date, holidays: IHoliday[]) => {
  return (
    ![0, 6].includes(date.day()) &&
    (holidays
      ? !holidays.some(
          (holiday) =>
            moment(holiday.holidayDate).format('YYYYMMDD') === moment(date).format('YYYYMMDD'),
        )
      : true)
  );
};

export const addBusinessDays = (originalDate, numDaysToAdd, holidays) => {
  let daysRemaining = numDaysToAdd;
  const newDate = originalDate.clone();
  while (daysRemaining > 0) {
    newDate.add(1, 'd');
    if (isValidDate(newDate, holidays)) daysRemaining--;
  }
  return newDate;
};

export const addBusinessWeeks = (originalDate, numWeeksToAdd, holidays) => {
  const newDate = originalDate && originalDate.clone();
  newDate.add(numWeeksToAdd, 'weeks');
  while (!isValidDate(newDate, holidays)) {
    newDate.add(1, 'days');
  }
  if (newDate.day() === 6) {
    newDate.add(2, 'days');
  } else if (newDate.day() === 0) {
    newDate.add(1, 'days');
  }
  return newDate;
};

export const addBusinessMonths = (originalDate, numMonthsToAdd, holidays) => {
  const newDate = originalDate && originalDate.clone();
  newDate.add(numMonthsToAdd, 'months');
  while (!isValidDate(newDate, holidays)) {
    newDate.add(1, 'days');
  }
  if (newDate.day() === 6) {
    newDate.add(2, 'days');
  } else if (newDate.day() === 0) {
    newDate.add(1, 'days');
  }
  return newDate;
};

export function getFormattedDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function isValidISOString(dateString) {
  const dateParsed = new Date(dateString);
  if (!isNaN(dateParsed.valueOf()) && dateParsed.toISOString() === dateString) {
    return true;
  }
  return false;
}
